import { useEffect } from 'react';
import { useNavigate } from 'react-router';

interface RedirectProps {
  to: string;
  replace?: boolean;
  delay?: number;
}

const Redirect = ({ to, replace = true, delay = 0 }: RedirectProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(to, { replace });
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [to, replace, delay, navigate]);

  return null;
};

export default Redirect;
